import { createFileRoute, redirect } from '@tanstack/react-router';

/** The old address of the session page; the session lives at `/play`. */
export const Route = createFileRoute('/in-game')({
  beforeLoad: () => {
    throw redirect({ to: '/play' });
  },
});
